import {Component, computed, inject, signal} from '@angular/core';
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {ReactiveFormsModule} from "@angular/forms";
import {RepoService} from "../services/repo.service";
import {InAppMessage} from "../models/inAppMessage";
import {MatDialog} from "@angular/material/dialog";
import {CreateInAppMessageComponent} from "./create-in-app-message/create-in-app-message.component";
import {Bu} from "../models/bu";
import {DatePipe, NgOptimizedImage} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {toSignal} from "@angular/core/rxjs-interop";
import {BuType} from "../models/bu-types";

@Component({
  selector: 'app-in-app-messages',
  standalone: true,
  imports: [
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    DatePipe,
    CreateInAppMessageComponent,
    MatTooltip,
  ],
  templateUrl: './in-app-messages.component.html',
  styleUrl: './in-app-messages.component.css'
})
export class InAppMessagesComponent {

  repo = inject(RepoService);
  dialog = inject(MatDialog);

  bus = Bu.bus;

  createMessageOn = signal<boolean>(false);
  displayedData = signal<{
    bu: BuType,
    currentInAppMessage: InAppMessage,
    allMessages: InAppMessage[]
  } | null>(null);

  allMessages = toSignal(this.repo.inAppMessagesSubject, {initialValue: []});

  messagesByBu = computed(() => {
    return new Map(this.allMessages().map(msg => [msg.bu, msg]));
  });

  async removeMessage(message: InAppMessage) {
    await this.repo.removeInAppMessage(message)

  }


  openCreateDialog(bu: BuType) {
    this.displayedData.set({
      bu: bu,
      currentInAppMessage: this.getCurrentMessageForBu(bu) ?? null,
      allMessages: this.allMessages()
    });

    this.createMessageOn.set(true);
  }

  getCurrentMessageForBu(bu: BuType): InAppMessage | undefined {
    return this.messagesByBu().get(bu);
  }
}


